import { useMemo } from "react";
import { useGetProjectFeeDetails } from "../../../api/services/project/projectApis";

export const useGetProjectFeeConfig = () => {
  const {
    data: projectFeeDetailsData,
    isFetching: isProjectFeeDetailsPending,
    isError: isProjectFeeDetailsError,
    refetchWithParams: getProjectFeeByProjectId,
  } = useGetProjectFeeDetails();

  const isLoading = useMemo(() => {
    return isProjectFeeDetailsPending;
  }, [isProjectFeeDetailsPending]);

  const isError = useMemo(() => {
    return isProjectFeeDetailsError;
  }, [isProjectFeeDetailsError]);

  const projectFeeBillingCurrency = useMemo(() => {
    if (projectFeeDetailsData) {
      return projectFeeDetailsData?.currency;
    }
  }, [projectFeeDetailsData]);

  const fetchProjectFeeDetails = (projectId: string) => {
    getProjectFeeByProjectId(projectId);
  };

  return {
    isLoading,
    isError,
    projectFeeBillingCurrency,
    fetchProjectFeeDetails,
  };
};
